import loadable from '../../utils/loadable';
const Text = loadable(() => import('@lexus.com/ui/dist/components/Text'));

export default Text;
